import {combineReducers}       from 'redux'
import CurrentRules            from "./CurrentRules"
import IsFetching              from "./IsFetching"

export const EngagementRules = combineReducers({
  CurrentRules,
  IsFetching
})
